import React from 'react';
import { motion } from 'framer-motion';
export function SlideTransition({
  children,
  direction = 1
}: {
  children: ReactNode;
  direction?: number;
}) {
  return <motion.div key="slide" initial={{
    opacity: 0,
    x: 20 * direction
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20 * direction
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="w-full h-full flex flex-col absolute inset-0 bg-[#0B1623]" data-id="element-185">
      {children}
    </motion.div>;
}